import { DLGetSettings } from './../DL/Settings'

import { LogErrors } from './../LogErrors'
import { UpdateSessionInfo } from './Sessions'
import { ValidateSqlInjection } from './Security'

import { SaveWebTheme as DLSaveWebTheme, SaveWebFontSize as DLSaveWebFontSize, UpdateNickname as DLUpdateNickname } from './../DL/Settings'


const GetCurrentTheme = async () => {
  try {
    let theme

    //Validar que exista la info del usuario en el session storage
    if (!sessionStorage.getItem('userData')) {
        return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
    }
    
    //Obtener la info del usuario desde el session storage
    const userData = JSON.parse(sessionStorage.getItem('userData'))

    //Comprobar varias propiedades para ver si está correcta la info del usuario
    const tmpTheme = userData?.user?.userTheme

    if (!tmpTheme) {
      theme = 1
    }
    
    // Validar que sea un número válido, si no, asignar 1 (tema predeterminado)
    theme = Number.isInteger(tmpTheme) ? tmpTheme : 1

    // Aplicar o quitar la clase según el tema seleccionado
    document.body.classList.toggle('DarkTheme', theme === 2)

    return { success: true, data: theme }
  } catch (error) {
    await LogErrors('GetCurrentTheme - BL Settings', error)
    return { success: false, message: '' } // Retorno explícito en caso de error
  }
}

const ChangeTheme = async (idTheme = null) => {
  try {
    // Validar que sea un número válido, si no, asignar 1 (tema predeterminado)
    let theme = Number.isInteger(idTheme) ? idTheme : 1

    // Aplicar o quitar la clase según el tema seleccionado
    document.body.classList.toggle('DarkTheme', theme === 2)

    return { success: true, data: theme }
  } catch (error) {
    await LogErrors('ChangeTheme - BL Settings', error)
    return { success: false, message: '' } // Retorno explícito en caso de error
  }
}

const ChangeFontSize = async (idFontSize = null) => {
  try {
    // Validar que sea un número válido, si no, asignar 1 (tamaño normal)
    const fontSize = Number.isInteger(idFontSize) ? idFontSize : 1

    // Remover todas las clases antes de aplicar la nueva
    document.body.classList.remove('SmallFont', 'BigFont')

    // Aplicar la clase correspondiente
    if (fontSize === 0) {
      document.body.classList.add('SmallFont')
    } else if (fontSize === 2) {
      document.body.classList.add('BigFont')
    }

    return { success: true, data: fontSize }
  } catch (error) {
    await LogErrors('ChangeFontSize - BL Settings', error)
    return { success: false, message: '' } // Retorno explícito en caso de error
  }
}

const SetDefaultWebTheme = async () => {
  try {
    //Validar que exista la info del usuario en el session storage
    if (!sessionStorage.getItem('userData')) {
      return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
    }
    
    //Obtener la info del usuario desde el session storage
    const userData = JSON.parse(sessionStorage.getItem('userData'))

    //Comprobar varias propiedades para ver si está correcta la info del usuario
    const theme = userData?.user?.userTheme
    
    const response = await ChangeTheme(theme)

    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    await LogErrors('SetDefaultWebTheme - BL Settings', error)
    return { success: false, data: 1, message: '' }
  }
}

const SaveWebTheme = async (idTheme) => {
  try {
    //Validar que exista la info del usuario en el session storage
    if (!sessionStorage.getItem('userData')) {
        return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
    }
    
    //Obtener la info del usuario desde el session storage
    const userData = JSON.parse(sessionStorage.getItem('userData'))

    const token = userData?.token
    if (!token) {
      return { success: false, message: '' }
    }

    const user = userData?.user
    if (!user) {
      return { success: false, message: '' }
    }

    userData.user.userTheme = idTheme

    //Agregar llamado a la API para guardar el tema
    const response = await DLSaveWebTheme(token, idTheme)

    if (response.success) {
      await UpdateSessionInfo(userData)

      await ChangeTheme(idTheme)

      return { success: true, data: idTheme }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    await LogErrors('SaveWebTheme - BL Settings', error)
    return { success: false, message: '' }
  }
}

const SaveWebFontSize = async (idFontSize) => {
  try {
    //Validar que exista la info del usuario en el session storage
    if (!sessionStorage.getItem('userData')) {
      return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
    }
    
    //Obtener la info del usuario desde el session storage
    const userData = JSON.parse(sessionStorage.getItem('userData'))

    const token = userData?.token
    if (!token) {
      return { success: false, message: '' }
    }

    const user = userData?.user
    if (!user) {
      return { success: false, message: '' }
    }

    userData.user.fontZise = idFontSize
    
    const response = await DLSaveWebFontSize(token, idFontSize)

    if (response.success) {
      await UpdateSessionInfo(userData)

      await ChangeFontSize(idFontSize)

      return { success: true, data: idFontSize }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    await LogErrors('SaveWebFontSize - BL Settings', error)
    return { success: false, message: '' }
  }
}














































/**
 * Función para obtener las configuraciones de la plataforma
 * @param {string} language 
 * @param {boolean} isLoginPage 
 * @returns 
 */
const GetSettings = async (language = null, isLoginPage = false) => {
    try {
      const settings = await DLGetSettings(language, isLoginPage) // Esperar a que getSettings termine

      if (settings === null) {
        return null
      }
      
      return settings
    } catch (error) {
      console.log(error)
    }
}





const GetMenu = () => {
  try {
    const settings = DLGetSettings() // Esperar a que getSettings termine

    if (settings === null || (settings.menu === undefined || settings.menu === null)) {
      return null
    }

    return settings.menu
  } catch (error) {
    console.log(error)
  }
}





const GetMessages = () => {
  try {
    const settings = DLGetSettings() // Esperar a que getSettings termine
    
    if (settings === null || (settings.messages === undefined || settings.messages === null)) {
      return null
    }

    return settings.messages
  } catch (error) {
    console.log(error)
  }
}





/**
 * Función que obtiene el tema de las configuraciones del usuario
 * @returns array
 */
const GetTheme = () => {
  try {
    const settings = DLGetSettings() // Esperar a que getSettings termine

    if (settings === null || (settings.theme === undefined || settings.theme === null)) {
      return null
    }

    return settings.theme
  } catch (error) {
    console.log(error)
  }
}

/**
 * Función que establece el nuevo tema en las configuraciones del usuario
 * @param {string} $theme 
 * @returns boolean
 */
const SetTheme = ($theme) => {
  try {
    const settings = DLGetSettings() // Esperar a que getSettings termine

    if (settings === null || (settings.theme === undefined || settings.theme === null)) {
      return null
    }

    if ($theme === null || $theme === '' || ($theme.toLowerCase() !== 'dark' && $theme.toLowerCase() !== 'light')) {
      return false
    }

    settings.theme = $theme.toLowerCase()
    sessionStorage.setItem('settings',JSON.stringify(settings))
    return true
  } catch (error) {
    console.log(error)
  }
}

// const GetLanguage = () => {
//   try {
//     const settings = DLGetSettings() // Esperar a que getSettings termine
    
//     if (settings === null || (settings.messages === undefined || settings.messages === null)) {
//       return null
//     }

//     return settings.messages
//   } catch (error) {
//     console.log(error)
//   }
// }


/**
 * Función que obtiene el alias del usuario
 * @returns 
 */
const GetUserData = async () => {
    try {
        //Validar que exista la info del usuario en el session storage
        if (!sessionStorage.getItem('userData')) {
            return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
        }
        
        //Obtener la info del usuario desde el session storage
        const userData = JSON.parse(sessionStorage.getItem('userData'))
        
        const name = userData?.user?.name
        if (!name) {
          return { success: false, message: 'No ha sido posible obtener la información de tu cuenta' }
        }

        const lastName = userData?.user?.lastName
        if (!lastName) {
          return { success: false, message: 'No ha sido posible obtener la información de tu cuenta' }
        }
        
        const email = userData?.user?.email
        if (!email) {
          return { success: false, message: 'No ha sido posible obtener la información de tu cuenta' }
        }

        const nickname = userData?.user?.nickname
        if (!nickname) {
          return { success: false, message: 'No ha sido posible obtener la información de tu cuenta' }
        }

        const userInfo = {
          name: `${name} ${lastName}`,
          email: email,
          nickname: nickname
        }

        return { success: true, data: userInfo }
    } catch (error) {
        await LogErrors('GetUserData - Navigation BL', error)
        return { success: false, message: 'No ha sido posible obtener la información de tu cuenta' }
    }
}

/**
 * Función que actualiza el alias del usuario
 * @returns 
 */
const UpdateNickname = async (nickname) => {
    try {
      //Validar que exista la info del usuario en el session storage
      if (!sessionStorage.getItem('userData')) {
          return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
      }
      
      //Obtener la info del usuario desde el session storage
      const userData = JSON.parse(sessionStorage.getItem('userData'))

      const token = userData?.token
      if (!token) {
        return { success: false, message: '' }
      }

      if (!nickname || nickname === '') {
        return { success: false, message: '' }
      }

      // Validación de la info del cuadro de texto (misma regla que /confirm)
      const regex = /^[a-záéíóúüñ0-9\s]+$/

      if (!regex.test(nickname.toLowerCase())) {
        return { success: false, message: 'El alias contiene caracteres inválidos' }
      } else if (await ValidateSqlInjection(nickname)) {
        return { success: false, message: 'El alias contiene caracteres inválidos' }
      } else if (nickname.length > 25) {
        return { success: false, message: 'El alias puede ser de máximo 25 caracteres' }
      }

      const response = await DLUpdateNickname(nickname, token)
      
      if (response.success) {
        // Actualizar alias (o nickname) en la info de la sesión del usuario
        userData.user.nickname = nickname
        await UpdateSessionInfo(userData)

        return { success: true, data: null }
      } else {
        return { success: false, message: response.message }
      }
    } catch (error) {
        await LogErrors('UpdateNickname - BL Settings', error)
        return { success: false, message: 'No ha sido posible actualizar tu alias. Inténtalo nuevamente o inténtalo más tarde' }
    }
}

export { GetCurrentTheme, ChangeTheme, ChangeFontSize, SetDefaultWebTheme, SaveWebTheme, SaveWebFontSize, GetSettings, GetMenu, GetMessages, GetTheme, SetTheme, GetUserData, UpdateNickname };